export enum PermissionEnum {
  ADMIN = 'ADMIN',
  PAINT_SHOP_MANAGER = 'PAINT_SHOP_MANAGER',
  BIDDER = 'BIDDER',
  SURFACE_PREPARATION_ASSIGN = 'SURFACE_PREPARATION_ASSIGN',
  SURFACE_PREPARATION = 'SURFACE_PREPARATION',
  PRIMER_PAINTING_ASSIGN = 'PRIMER_PAINTING_ASSIGN',
  PRIMER_PAINTING = 'PRIMER_PAINTING',
  FIRE_PROTECTION_PAINTING_ASSIGN = 'FIRE_PROTECTION_PAINTING_ASSIGN',
  FIRE_PROTECTION_PAINTING = 'FIRE_PROTECTION_PAINTING',
  INTER_LAYER_PAINTING_ASSIGN = 'INTER_LAYER_PAINTING_ASSIGN',
  INTER_LAYER_PAINTING = 'INTER_LAYER_PAINTING',
  TOP_COAT_PAINTING_ASSIGN = 'TOP_COAT_PAINTING_ASSIGN',
  TOP_COAT_PAINTING = 'TOP_COAT_PAINTING',
  THICKNESS_MEASUREMENT = 'THICKNESS_MEASUREMENT',
  THICKNESS_MEASUREMENT_ASSIGN = 'THICKNESS_MEASUREMENT_ASSIGN',
  SITE_DATA_VIEW = 'SITE_DATA_VIEW',
  SITE_DATA_EDIT = 'SITE_DATA_EDIT',
  ITEMS_IMPORT = 'ITEMS_IMPORT',
  CATALOG_VIEW = 'CATALOG_VIEW',
  PAINT_LIST_VIEW = 'PAINT_LIST_VIEW',
  PAINT_WAREHOUSE_VIEW = 'PAINT_WAREHOUSE_VIEW',
  DELIVERY_LIST_VIEW = 'DELIVERY_LIST_VIEW',
  RELEASE_DELIVERY_ITEMS = 'RELEASE_DELIVERY_ITEMS',
  REOPEN_OUTGOING_DELIVERY = 'REOPEN_OUTGOING_DELIVERY',
  OUTGOING_DELIVERY_CREATE_VIEW = 'OUTGOING_DELIVERY_CREATE_VIEW',
  ITEM_MANUAL_SCAN_FOR_SHIPMENT = 'ITEM_MANUAL_SCAN_FOR_SHIPMENT',
  INCOMING_DELIVERY_CREATE_VIEW = 'INCOMING_DELIVERY_CREATE_VIEW',
  WORK_LOAD_MOBILE = 'WORK_LOAD_MOBILE',
  ITEMS_ON_SITE_REPORT = 'ITEMS_ON_SITE_REPORT',
  CONTRACTOR_LIST_VIEW = 'CONTRACTOR_LIST_VIEW',
  MANUAL_WORKFLOW_MOVEMENT = 'MANUAL_WORKFLOW_MOVEMENT',
}

